import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import { AccountCallback } from "../pages/Account";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import Interactive3D from "./Interactive3D";
import CartDrawer from "./store/CartDrawer";

export default function Layout() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash.includes("session_id=")) return;
    if (hash) {
      const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 150);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return (
    <div className="min-h-screen bg-[#3915AA] text-white" data-testid="app-layout">
      <SiteHeader />
      <main className="pt-[156px] md:pt-[100px] lg:pt-[144px]">
        {hash.includes("session_id=") ? <AccountCallback /> : <Outlet />}
      </main>
      <Footer />
      <WhatsAppFloat />
      <Interactive3D />
      <CartDrawer />
    </div>
  );
}
